import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import ReportValues from "../../../domains/ReportComparison/ReportValues";

import { SLICE_NAME } from "./types";

interface ComponentsState {
  isLoading: boolean
  hasErrorLoadingComponents: boolean
  components: any[]
  // componentsMissingValues: Array<string>
  // formInitialValues: ReportValues
  // isFormLoading: boolean
  // hasErrorLoadingForm: boolean
  // isFormSubmitting: boolean
  // hasErrorSubmittingForm: boolean
  // isAlertModalOpen: boolean
  // isBrowseFilesModalOpen: boolean
  // shouldShowPDFVisualizer: boolean
  // currentReportId: string,
  // shouldProceedWithoutRecommendation: boolean;
}

const initialState: ComponentsState = {
  isLoading: false,
  hasErrorLoadingComponents: false,
  components: [],
  // componentsMissingValues: [],
  // formInitialValues: {},
  // isFormLoading: false,
  // hasErrorLoadingForm: false,
  // isFormSubmitting: false,
  // hasErrorSubmittingForm: false,
  // isAlertModalOpen: false,
  // isBrowseFilesModalOpen: false,
  // shouldShowPDFVisualizer: false,
  // currentReportId: "",
  // shouldProceedWithoutRecommendation: false,
};

export const componentsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setComponentLoadingStatus: (
      state,
      action: PayloadAction<{ isLoading: boolean }>,
    ) => {
      state.isLoading = action.payload.isLoading;
    },
    setComponentsSuccess: (
      state,
      action: PayloadAction<{
        components: Array<any>
        isLoading: boolean
      }>,
    ) => {
      const { components, isLoading } = action.payload;
      state.components = components;
      state.isLoading = isLoading;
    },
    setComponentsError: (state, action: PayloadAction<{hasErrorLoadingComponents: boolean, isLoading: boolean}>) => {
      const { hasErrorLoadingComponents, isLoading } = action.payload;
      state.isLoading = isLoading;
      state.hasErrorLoadingComponents = hasErrorLoadingComponents;
    }
    // getComponents: (state, action: PayloadAction<any[]>) => {
    //   state.components = [...action.payload];
    // }
    // components: [],
    // selectComponentById: (
      
    // )
    // setComponentsMissingValues: (
    //   state: ComponentsReportTableState,
    //   action: PayloadAction<Array<string>>,
    // ) => {
    //   state.componentsMissingValues = [...action.payload];
    // },
    // initializeForm: state => {
    //   state.isFormLoading = true;
    // },
    // setFormInitialValues: (
    //   state,
    //   action: PayloadAction<{ values: ReportValues }>,
    // ) => {
    //   state.isFormLoading = false;
    //   state.formInitialValues = action.payload.values;
    // },
    // initializeFormError: state => {
    //   state.isFormLoading = false;
    //   state.hasErrorLoadingForm = true;
    // },
    // setCurrentReportId: (state, action: PayloadAction<string>) => {
    //   state.currentReportId = action.payload;
    // },
    // setValue: (
    //   state,
    //   action: PayloadAction<{ fieldName: string; value: string | number }>,
    // ) => {
    //   const fieldName = action.payload.fieldName;
    //   const updatedValues = {
    //     ...state.formInitialValues,
    //     [fieldName]: {
    //       ...state.formInitialValues[fieldName],
    //       value: action.payload.value,
    //     },
    //   };
    //   state.formInitialValues = updatedValues as ReportValues;
    // },

    // updateEntry: (
    //   state,
    //   action: PayloadAction<{
    //     value?: number
    //     componentId?: string
    //     unit?: string
    //     hasWarning?: boolean
    //     warning?: string
    //     isOCRChecked?: boolean
    //   }>,
    // ) => {
    //   state.formInitialValues[action?.payload?.componentId as string] = {
    //     ...state.formInitialValues[action?.payload?.componentId as string],
    //     unit: action?.payload?.unit as string,
    //     value: String(action.payload.value),
    //     OCRWarning: {
    //       warning: action?.payload?.warning as string,
    //       hasWarning: action?.payload?.hasWarning as boolean,
    //     },
    //     isOCRChecked: action.payload.isOCRChecked,
    //   };
    // },
    // removeOCRWarning: (state, action: PayloadAction<string>) => {
    //   state.formInitialValues[action.payload] = {
    //     ...state.formInitialValues[action.payload],
    //     OCRWarning: {
    //       hasWarning: false,
    //       warning: "",
    //     },
    //     isOCRChecked: true,
    //   };
    // },
    // submitForm: state => {
    //   state.isFormSubmitting = true;
    // },
    // submitFormSuccess: state => {
    //   state.isFormSubmitting = false;
    //   state.hasErrorSubmittingForm = false;
    // },
    // submitFormError: state => {
    //   state.isFormSubmitting = false;
    //   state.hasErrorSubmittingForm = true;
    // },
    // openAlertModal: state => {
    //   state.isAlertModalOpen = true;
    // },
    // closeAlertModal: state => {
    //   state.isAlertModalOpen = false;
    // },
    // clearForm: state => {
    //   state.formInitialValues = {};
    // },
    // openBrowseFilesModal: state => {
    //   state.isBrowseFilesModalOpen = true;
    // },
    // closeBrowseFilesModal: state => {
    //   state.isBrowseFilesModalOpen = false;
    // },
    // togglePDFVisualizer: (state, action: PayloadAction<boolean>) => {
    //   state.shouldShowPDFVisualizer = action.payload;
    // },
    // shouldProceedWithoutRecommendation: (state, action: PayloadAction<boolean>) => {
    //   state.shouldProceedWithoutRecommendation = action.payload;
    // }
  },
});

export const {
  setComponentLoadingStatus,
  setComponentsSuccess,
  setComponentsError,
  // setComponentsMissingValues,
  // setFormInitialValues,
  // setValue,
  // initializeFormError,
  // initializeForm,
  // submitFormError,
  // submitForm,
  // submitFormSuccess,
  // openAlertModal,
  // closeAlertModal,
  // clearForm,
  // openBrowseFilesModal,
  // closeBrowseFilesModal,
  // togglePDFVisualizer,
  // setCurrentReportId,
  // updateEntry,
  // removeOCRWarning,
  // shouldProceedWithoutRecommendation,
} = componentsSlice.actions;

export default componentsSlice.reducer;
